<template>
  <div class="resource_preview_dialog" :style="'height:'+windowHeight+'px'">
    <div class="resource_preview_dialog_left">
      <h2>{{resourceInfo.name}}</h2>
      <ul>
        <li>
          <p>分类：</p>
          <p>{{resourceInfo.classification}}</p>
        </li>
        <li>
          <p>上传人：</p>
          <p>{{resourceInfo.uploader}}</p>
        </li>
        <li>
          <p>上传时间：</p>
          <p>{{resourceInfo.uploadTime}}</p>
        </li>
      </ul>
      <el-button @click="clickConfirm">{{confirm}}</el-button>
    </div>
    <div class="resource_preview_dialog_right">
      <div class="resourcContent" :style="resourcContentStyle">
        <div v-if="resourceVisible==1" class="img_wrap">
          <viewer :images="[resourceUrl]" style="width:100%;height:100%">
            <img v-for="(src,i) in [resourceUrl]" :src="src" :key="i">
          </viewer>
        </div>
        <div v-if="resourceVisible==2" :class="'pdf_wrap '+pdfEnlargStyle+' '+pageStyle" @dblclick="pdfEnlarge(pageNum)">
          <pdf ref="pdf" 
          :src="resourceUrl" 
          :page="pageNum"
          :rotate="pageRotate"
          @password="password"
          @progress="loadedRatio = $event"
          @page-loaded="pageLoaded($event)"
          @num-pages="pageTotalNum=$event" 
          @error="pdfError($event)"
          @link-clicked="page = $event" class="pdf_box"></pdf>
          <i class="el-icon-arrow-left btn-def btn-pre" @click.stop="prePage" @dblclick.stop=""></i>
          <i class="el-icon-arrow-right btn-def btn-next" @click.stop="nextPage" @dblclick.stop=""></i>
          <span class="pdfCurrentPage">{{pageNum}}/{{pageTotalNum}}</span>
          <div class="operating_btn">
            <div>
              <i class="el-icon-refresh-left" @click="counterClock" @dblclick.stop=""></i>
              <i class="el-icon-refresh-right" @click="clock" @dblclick.stop=""></i>
              <i class="el-icon-zoom-in" @click="pdfEnlargeBtn" @dblclick.stop="" v-if="pdfEnlargeSign==1"></i>
              <i class="el-icon-zoom-out" @click="pdfNarrowBtn" @dblclick.stop="" v-if="pdfEnlargeSign==2"></i>
              <!--<el-button class="btn-def" @click.stop="clock">顺时针</el-button>-->
              <!--<el-button class="btn-def" @click.stop="counterClock">逆时针</el-button>-->
            </div>
            <div>
              <!--<span> 进度：{{loadedRatio}}</span>-->
              <!--<span>页面加载成功: {{curPageNum}}</span>-->
            </div>
          </div>
        </div>
        <audio :src="resourceUrl" controls="controls" v-if="resourceVisible==3"></audio>
        <video v-if="resourceVisible==4" id="video1" class="video-js" controls controlsList="nodownload" muted="muted" preload="auto" width="800" height="500" :poster="posterSrc" data-setup='{"example_option":true}'>
          <source id="sourceBox" :src="resourceUrl" type='video/mp4'>
          <p class="vjs-no-js">不支持播放</p>
        </video>
      </div>
    </div>
  </div>
</template>
<script>
  import pdf from 'vue-pdf'
  import './viewResource.scss'
  export default {
    name: 'viewResourceDialog',
    components:{
      'pdf': pdf
    },
    props: {
      confirm:{
        type:[String],
        default:'好的'
      },
      showModalconfirm:{
        type:Boolean,
        default:false
      },
      resourceVisible:{
        type:Number,
        default:0
      },
      resourceUrl:{
        type: String,
        default: ''
      },
      posterSrc:{
        type: String,
        default: ''
      },
      resourceInfo: {
        type: Object,
        default: function(){
          return {
            name: '',
            classification: '',
            uploader: '',
            uploadTime: ''
          }
        }
      }
    },
    data(){
      return {
        show:false,
        pageNum:1,
        pageTotalNum:1,
        pageRotate:0,
        // 加载进度
        loadedRatio:0,
        curPageNum:0,
        deg:0,
        multiples:1,
        numPages:1,
        resourcContentStyle:'',
        pdfEnlargStyle:'',
        pageStyle:'',
        pdfEnlargeSign:1,
        windowHeight: window.innerHeight
      }
    },
    created(){
      console.log(this.windowHeight)
    },
    methods: {
      pdfTask(pdfUrl){
        var that = this
        var loadingTask = pdf.createLoadingTask(pdfUrl)  
        loadingTask.then(pdf => {
            that.pdfUrl = loadingTask
            that.numPages = pdf.numPages
          }).catch((err) => {
            console.error('pdf加载失败')
        })
      },
      pdfEnlarge(i){
        if(this.pdfEnlargeSign==1){
          this.pdfEnlargeSign = 2
          this.pdfEnlargStyle="pdf_enlarge"
          this.pageStyle="page_style"
        }else{
          this.pdfEnlargeSign = 1
          this.pdfEnlargStyle=""
          this.pageStyle=""
        }
        
      },
      pdfEnlargeBtn(){
        this.pdfEnlargeSign = 2
        this.pdfEnlargStyle="pdf_enlarge"
        this.pageStyle="page_style"
      },
      pdfNarrowBtn(){
        this.pdfEnlargeSign = 1
        this.pdfEnlargStyle=""
        this.pageStyle=""
      },
      prePage(e){
        var p = this.pageNum
        p = p>1?p-1:this.pageTotalNum
        this.pageNum = p
        if(this.pdfEnlargeSign==1){
          e.target.parentNode.parentNode.scrollTo(0,0);
        }else{
          e.target.parentNode.scrollTo(0,0);
        }
      },
      nextPage(e){
        var p = this.pageNum
        p = p<this.pageTotalNum?p+1:1
        this.pageNum = p
        if(this.pdfEnlargeSign==1){
          e.target.parentNode.parentNode.scrollTo(0,0);
        }else{
          e.target.parentNode.scrollTo(0,0);
        }
      },
      clock(){
        this.pageRotate += 90 
      },
      counterClock(){
        this.pageRotate -= 90 
      },
      password(updatePassword, reason) {
        updatePassword(prompt('password is "123456"'))
      },
      pageLoaded(e){
        this.curPageNum = e
      },
      pdfError(error){
        console.error(error)
      },
      pdfPrintAll(){
        this.$refs.pdf.print()
      },
      pdfPrint(){
        this.$refs.pdf.print(100,[1,2])
      },
      //取消
      clickCancel(){
        this.show = false
        this.$emit('onclickCancel')
        this.pageNum = 1
        this.pageRotate = 0
      },
      //确定
      clickConfirm(){
        this.show = false
        this.$emit('oncilckConfirm')
        this.pageNum = 1
        this.pageRotate = 0
      },
    },
    watch:{
      showModalconfirm(val){
        this.show = val
        if(this.resourceVisible==2){
          this.pdfTask(this.resourceUrl)
          this.resourcContentStyle="overflow-y: auto;" 
        }else{
          this.resourcContentStyle="display: flex; justify-content: center; align-items: center;"
        }
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/views/course/components/viewResourceDialog.vue